module.exports = __webpack_public_path__ + "img/curtains.15c1443c.png";